<template>

    <article class="carousel">

        <div class="container">

            <div class="templates">

                <div ref="step1">
                    <img src="/img/discovery/continue-1.svg" class="img-carousel mr__8">
                </div>
                <div ref="step2">
                    <img src="/img/discovery/continue-2.svg" class="img-carousel mr__8">
                </div>
                <div ref="step3">
                    <img src="/img/discovery/continue-3.svg" class="img-carousel">
                </div>
            </div>
            <div class="indicators" v-show="!isDesktop">
                <div class="point" :class="{'active-point': activePoint1}"></div>
                <div class="point" :class="{'active-point': activePoint2}"></div>
                <div class="point" :class="{'active-point': activePoint3}"></div>
            </div>
        </div>



    </article>

</template>

<script>
import Markdown from '../../components/Markdown'

export default {

    name: 'discovery-carousel',

    components: {
        Markdown
    },

    watch: {
        'tipsVisibility.step1' (value) {
            if(value && value > this.tipsVisibility.step2) {
                this.pointBestVisibility = this.ENUM_STEP.STEP1
            }
        },
        'tipsVisibility.step2' (value) {
            if(value && value > this.tipsVisibility.step1 && value > this.tipsVisibility.step3) {
                this.pointBestVisibility = this.ENUM_STEP.STEP2
            }
        },
        'tipsVisibility.step3' (value) {
            if(value && value > this.tipsVisibility.step2) {
                this.pointBestVisibility = this.ENUM_STEP.STEP3
            }
        }
    },

    computed: {
        activePoint1() {
            return this.isDesktop
                ? this.templateArrayIndex%3 === 0
                : this.pointBestVisibility === this.ENUM_STEP.STEP1
        },
        activePoint2() {
            return this.isDesktop
                ? this.templateArrayIndex%3 === 1
                : this.pointBestVisibility === this.ENUM_STEP.STEP2
        },
        activePoint3() {
            return this.isDesktop
                ? this.templateArrayIndex%3 === 2
                : this.pointBestVisibility === this.ENUM_STEP.STEP3
        }
    },

    data() {
        return {
            ENUM_STEP: {
                STEP1: 'step1',
                STEP2: 'step2',
                STEP3: 'step3'
            },
            templateArrayIndex: 40,
            pointBestVisibility: 0,
            tipsVisibility: {
                step1: 0,
                step2: 0,
                step3: 0
            },
            tipsObersever: {
                step1: null,
                step2: null,
                step3: null
            }
        }
    },

    mounted() {
        this.tipsObserver()
    },

    methods: {
        tipsObserver() {
            this.createOberserver('step1')
            this.createOberserver('step2')
            this.createOberserver('step3')
        },

        createOberserver(name) {
            const imageElement = this.$refs[name]
            this.tipsObersever[name] = new IntersectionObserver(
                (entries) => {
                    const entry = entries[0]
                    this.tipsVisibility[name] = Math.round(entry.intersectionRatio * 100)
                },
                {
                    threshold: Array.from({ length: 101 }, (_, i) => i / 100) // visibility percentage
                }
            )
            this.tipsObersever[name].observe(imageElement)
        },

        destroyObersever(observer) {
            if (this.tipsObersever[observer]) {
                this.tipsObersever[observer].disconnect()
            }
        }
    },

    beforeDestroy() {
        this.destroyObersever('step1')
        this.destroyObersever('step2')
        this.destroyObersever('step3')
    }

}
</script>

<style lang="scss" scoped>

.carousel {
    display: flex;
    flex-direction: column;
    padding: 0 16px;

    .container {
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .templates {
            width: 100vw;
            overflow-x: scroll;
            padding: 0 16px;
            display: flex;
            flex-direction: row;
            overflow: scroll;
            @media screen and (min-width: $above-tablet-length) {
                width: fit-content;
                padding: 0;
                margin: 0;
                position: relative;
                align-items: center;
            }



            /* Hide scrollbar for Chrome, Safari and Opera */
            &::-webkit-scrollbar {
                display: none;
            }
            /* Hide scrollbar for IE, Edge and Firefox */
            -ms-overflow-style: none;  /* IE and Edge */
            scrollbar-width: none;  /* Firefox */
        }

        .indicators {
            margin-top: 24px;
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            .point {
                margin: 0 2px;
                height: 4px;
                width: 4px;
                border-radius: 4px;
                background: rgba(50, 163, 235, 0.48);
            }

            .active-point {
                width: 12px;
                height: 4px;
                border-radius: 4px;
                background: $aquamarine;
            }
        }

        .round-white {
            padding: 6px;
            border-radius: 30px;
            background-color: $white;
            border: 2px solid $silver;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            > img {
                width: 20px;
                object-fit: contain;
            }
        }

        .round-white-left {
            position: absolute;
            left: -51px;
        }

        .round-white-right {
            position: absolute;
            right: -51px;
        }
    }
}

</style>
